export const contentDict = {
  title: "Logzilla",                // Display name
  finishDate: new Date("2023-11-19"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.2,
    "HuggingFace Transformers": 0.1, 
    "Flask": 0.2, 
    "PostgreSQL": 0.1,
    "JavaScript": 0.2, 
    "React": 0.2, 
  }, 
  description: 
    `Logzilla summarizes system log files, by pre-filtering entries using selected keywords, parsing and tokenizing remaining entries and adding them to a database. The chat with the user is used to build an SQL query with which we retrieve relevant entries from the database and build a dynamic summary including references.`,
  tags: ["HackaTUM", "Webapp", "Devtool"],
  github: "hhttps://github.com/HackaTUM-2023-MACP/Logzilla/tree/main",    // Can also be `null`
  website: null,       // Can also be `null`
  youtube: "https://www.youtube.com/watch?v=5oBkJUfh7PI",
  images: [
    // "https://github.com/HackaTUM-2023-MACP/Logzilla/raw/main/frontend-react-client/public/logo512.png",
    "https://github.com/HackaTUM-2023-MACP/Logzilla/raw/main/frontend-react-client/public/demo_short_small.gif"
  ],
  coverImg: "https://github.com/HackaTUM-2023-MACP/Logzilla/raw/main/frontend-react-client/public/logo512.png",
  mainColor: "#80f1e7",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }